import { z } from 'zod';

/**
 * Valida as VITE_* no boot — env faltando derruba a aplicação com mensagem nomeando a
 * variável, nunca produz `undefined` silencioso dentro de uma URL de fetch.
 */
const EnvSchema = z.object({
  VITE_BFF_BASE_URL: z.string().url(),
  VITE_API_BASE_URL: z.string().url(),
  VITE_KEYCLOAK_BASE_URL: z.string().url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
});

export type AppEnv = z.infer<typeof EnvSchema>;

declare global {
  interface Window {
    __ENV__?: Record<string, string | undefined>;
  }
}

let cached: AppEnv | null = null;

export function loadEnv(source: ImportMetaEnv = import.meta.env): AppEnv {
  if (cached) return cached;

  const runtimeEnv = typeof window !== 'undefined' ? window.__ENV__ : undefined;

  const cleanedRuntime: Record<string, string> = {};
  if (runtimeEnv) {
    for (const [key, value] of Object.entries(runtimeEnv)) {
      if (typeof value === 'string' && value.trim() !== '' && !value.startsWith('${')) {
        cleanedRuntime[key] = value.trim();
      }
    }
  }

  const merged = {
    ...source,
    ...cleanedRuntime,
  };

  // Caminhos relativos usam a origem do portal; URLs absolutas legadas continuam válidas.
  for (const key of ['VITE_BFF_BASE_URL', 'VITE_API_BASE_URL'] as const) {
    const value = merged[key];
    if (typeof value === 'string' && /^\/bff(?:\/|$)/u.test(value) && typeof window !== 'undefined') {
      merged[key] = new URL(value, window.location.origin).href.replace(/\/$/u, '');
    }
  }
  const parsed = EnvSchema.safeParse(merged);
  if (!parsed.success) {
    const missing = parsed.error.issues.map((issue) => issue.path.join('.')).join(', ');
    throw new Error(`Configuração de ambiente inválida ou ausente: ${missing}`);
  }
  cached = parsed.data;
  return cached;
}
